import angular from 'angular';

angular
  .module('commonServices')
  .factory('optionsSvc', ['$q', '$filter', 'dataCache', 'zipCodes', optionsSvc]);

function optionsSvc($q, $filter, dataCache, zipCodes) {
  // This Service keeps the lists from dataCache and adds the defaultvalues for these lists if needed, and returns the list either with or without default.
  var optionsObject = null;

  function ready() {
    var deferred = $q.defer();

    var stripObjectsToListIds = function(idPropName, baseList) {
      var idList = [];
      for (var t = 0; t < baseList.length; t++) {
        idList.push(baseList[t][idPropName]);
      }
      return idList;
    };

    if (!optionsObject) {
      dataCache.ready().then(
        function() {
          optionsObject = {};
          optionsObject.defaults = {};

          optionsObject.country = stripObjectsToListIds('code', dataCache.getArray('country'));
          optionsObject.language = stripObjectsToListIds('code', dataCache.getArray('language'));
          optionsObject.legalForm = stripObjectsToListIds('id', dataCache.getArray('legalForm'));
          optionsObject.salutation = stripObjectsToListIds(
            'id',
            dataCache.getArray('salutation').sort(),
          );

          optionsObject.currency = ['EUR'];
          optionsObject.vatPercentage = dataCache.getArray('vatCategories');
          optionsObject.zipCodes = zipCodes.reduce(function(ar, el) {
            ar.push({
              code: el.code,
              name: el.name,
              label: el.code + ' ' + el.name,
            });
            if (el.nameNL && el.nameNL !== el.name)
              ar.push({
                code: el.code,
                name: el.nameNL,
                label: el.code + ' ' + el.nameNL,
              });
            if (el.nameFR && el.nameFR !== el.name && el.nameFR !== el.nameNL)
              ar.push({
                code: el.code,
                name: el.nameFR,
                label: el.code + ' ' + el.nameFR,
              });
            return ar;
          }, []);
          optionsObject.tenantConfiguration = [
            { label: 'Default', value: 0 },
            { label: 'Accountancy', value: 1 },
            { label: 'AccountancySouthAfrica', value: 2 },
            { label: 'AccountancyLuxembourg', value: 3 },
            { label: 'AccountancySpain', value: 4 },
            { label: 'AccountancyNetherlands', value: 5 },
          ];

          // Add defaults
          // TO AVOID CHANGING THE ORIGINAL lists, we put every default value in its own array, so we can work with concat in getOptionsWithDefaults

          // Creating the default object is different for different situations
          // Sometimes the element that is bound needs to be removed, sometimes set to null and sometimes set to empty string ('').
          // One factor seems to be the syntax for ng-options: when value is the whole object wich is recognised by 'track by' =>
          // track by int: empty string. track by string: remove
          // When the value is an int (Syntax with 'as': crmType.key as crmType.value) key needs to be set to null.

          //optionsObject.defaults.country = [{ name: 'Set a country' }];
          optionsObject.defaults.country = [null];
          //optionsObject.defaults.crmType = [{ key: null, value: 'Set a status' }];
          optionsObject.defaults.currency = [null];
          //optionsObject.defaults.emailType = [{ key: null, value: 'Set type' }];
          //optionsObject.defaults.language = [{ description: 'Set a language' }];
          optionsObject.defaults.language = [null];
          //optionsObject.defaults.legalForm = [{ id: '', description: 'Set a legalForm' }]; // Check
          optionsObject.defaults.legalForm = [null]; // Check
          //optionsObject.defaults.medium = [{ key: null, value: 'Set a medium' }];
          //optionsObject.defaults.purpose = [{ key: null, value: 'Set a purpose' }];
          //optionsObject.defaults.relationType = [{ key: null, value: 'Unknown' }];
          //optionsObject.defaults.salutation = [{ id: '', description: 'Set salutation' }];
          optionsObject.defaults.salutation = [null];
          optionsObject.defaults.vatPercentage = [
            {
              label: 'Set a percentage',
              value: null,
            },
          ];
          deferred.resolve(true);
        },
        function() {
          deferred.reject('dataCache not ready');
        },
      );
    } else {
      deferred.resolve('true');
    }
    return deferred.promise;
  }

  var getOptions = function(type) {
    return optionsObject[type];
  };

  var getOptionsWithDefault = function(type) {
    return optionsObject.defaults[type].concat(optionsObject[type]);
  };

  var getDefault = function(type) {
    return optionsObject.defaults[type];
  };

  return {
    ready: ready,
    getOptions: getOptions,
    getOptionsWithDefault: getOptionsWithDefault,
    getDefault: getDefault,
  };
}
